import React from "react";
import EmbedPage from "@/pages/EmbedPage";

export default function ShippingOnlyPage() {
  return (
    <EmbedPage
      srcPath="/embeds/shipping-only.html"
      titleKey="shippingOnly"
      testIdBase="shipping-only"
    />
  );
}
